import { createServer } from "miragejs";
import { default as env } from "environment";

export const makeServer = ({ environment = "development" } = {}) => {
  // Creates the mock Mirage.js server
  const server = createServer({
    environment,

    routes() {
      // Adds the base API URL from 'environment' to the beginning of all requests
      // e.g. https://api.hub.ucc-dev.vodafone.com
      this.urlPrefix = env.baseApi;
      this.timing = 1200;

      //
      //Leave this here as a template for future API calls.
      // this.post(
      //   "/cloud-numbers/number-request/" ,
      //   () =>
      //     new Response(
      //       200,
      //       {},
      //       { message: "Successfully created order", demandId: "123" }
      //     )
      // );
      // this.get(
      //   "/external-integrations/v1/solutions-hub/area",
      //   () => new Response(200, {}, areas),
      //   {
      //     timing: 1000,
      //   }
      // );

      // Allow regular requests to pass through
      this.passthrough("http://localhost:3000/**");
      this.passthrough(`${env.baseApi}/**`);
      this.passthrough(`${env.legacyBaseApi}/**`);
      this.passthrough(`${env.portalUrl}/**`);
      this.passthrough(`https://s3.eu-west-1.amazonaws.com/**`);
    },
  });

  return server;
};
